import { Helmet } from 'react-helmet'

interface IMeta {
    property: string
    content: string
}

interface ISEO {
    title: string
    description?: string
    meta?: IMeta[]
}

const SEO = ({ title, description, meta = [] }: ISEO) => (
    <Helmet
        htmlAttributes={{ lang: 'en' }}
        title={title}
        meta={[
            {
                name: 'description',
                content: description,
            },
            ...meta,
        ]}
    />
)

export default SEO
